/**
 * Route: /check-in-new/bulk-check-in
 * Multi-select check-in scaffolding: lists selected OneDrive docs with per-file expandable
 * sections (Class/Format, View Copy, Object connections, Release).
 * Layout: centered content column — same posture as Check-in New form (not full-bleed).
 */
import React from "react";
import { Stack } from "@fluentui/react";
import { useTheme } from "../../theme/OAS365Theme";
import CheckInNewBulkContent from "./CheckInNewBulkContent";

/** ~single check-in form width; leaves margin on wider viewports like the tab form UX */
const CHECKIN_BULK_PANEL_MAX_WIDTH_PX = 880;

export default function CheckInNewBulkPage() {
  const theme = useTheme();
  const gutterBg =
    theme.colors.mainAreaBackgroundColor?.trim?.() ?? "";
  const outerScrollBg =
    gutterBg !== "" ? gutterBg : theme.colors.backgroundColor;
  const formPanelBg = theme.colors.backgroundColor;

  return (
    <Stack
      enableScopedSelectors
      styles={{
        root: {
          background: formPanelBg,
          overflow: "hidden",
          height: "100%",
        },
      }}
      tokens={{ childrenGap: 0, padding: 0 }}
    >
      <Stack.Item
        grow
        styles={{
          root: {
            flex: "1 1 auto",
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <div
          style={{
            flex: "1 1 auto",
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            WebkitOverflowScrolling: "touch",
            backgroundColor: outerScrollBg,
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: CHECKIN_BULK_PANEL_MAX_WIDTH_PX,
              marginLeft: "auto",
              marginRight: "auto",
              padding: "12px 16px 40px",
              boxSizing: "border-box",
              backgroundColor: formPanelBg,
              minHeight: "100%",
            }}
          >
            <CheckInNewBulkContent />
          </div>
        </div>
      </Stack.Item>
    </Stack>
  );
}
